import React from 'react';
import Navbar from '../components/Layouts/Navbar';
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import ParallaxMainBanner from '../components/Startseite/StartseiteParallax';
import StartseiteStats from '../components/Startseite/StartseiteStats';
import StartseiteFeatures from '../components/Startseite/StartseiteFeatures';
import StartseiteExpertise from '../components/Startseite/StartseiteExpertise';
import StartseiteFaq from '../components/Startseite/StartseiteFaq';
import StartseiteCTA from '../components/Startseite/StartseiteCTA';
import ÜberunsMitgliedschaften from '../components/About/ÜberunsMitgliedschaften';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';

const Index = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('startseite_seo_title')}
                description={t('startseite_seo_description')}
                canonical={`${baseUrl}/`}
                openGraph={{
                    type: 'website',
                    locale: t('startseite_seo_locale'),
                    url: `${baseUrl}/`,
                    title: t('startseite_seo_ogTitle'),
                    description: t('startseite_seo_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1200,
                            height: 1200,
                            alt: t('startseite_seo_title'),
                            type: 'image/png',
                        }
                    ],
                    siteName: t('startseite_seo_title'),
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('startseite_seo_keywords'),
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data',
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH',
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel',
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString(),
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no',
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: '/images/favicon.png',
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: 'https://simplify-data.de/'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: 'https://simplify-data.com/'
                    }
                ]}
            />

            <Navbar />

            {/* Hero Section - Parallax Banner */}
            <ParallaxMainBanner />

            {/* Water Edge Transition */}
            <div className='water-edge' style={{
                height: 100,
                width: "100%",
                background: "linear-gradient(180deg, #00011D 0%, #080a3c 100%)",
                position: 'relative',
                zIndex: '1'
            }} />

            {/* Expertise-Bereich */}
            <StartseiteExpertise />

            {/* Statistiken & Erfolge */}
            <StartseiteStats />

            {/* Features & Vorteile */}
            <StartseiteFeatures />

            {/* CTA*/}
            <StartseiteCTA />

            {/* FAQ Section */}
            <StartseiteFaq />

            {/* Mitgliedschaften & Partner */}
            <ÜberunsMitgliedschaften />

            <Footer />
        </>
    );
}

export default Index;